import Add from "@mui/icons-material/Add";
import Checklist from "@mui/icons-material/Checklist";
import ConstructionIcon from "@mui/icons-material/Construction";
import Cottage from "@mui/icons-material/Cottage";
import HelpOutline from "@mui/icons-material/HelpOutline";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import MailLockIcon from "@mui/icons-material/MailLock";
import OutgoingMail from "@mui/icons-material/OutgoingMail";
import Portrait from "@mui/icons-material/Portrait";
import ReportProblemOutlined from "@mui/icons-material/ReportProblemOutlined";
import Search from "@mui/icons-material/Search";
import { Box, Stack } from "@mui/material";
import {
  LoadingSpinner,
  SidebarLink,
  SidebarSectionTitle,
} from "@tngtech/tng-ui";
import { use, useState } from "react";
import { ActionNames } from "tng-address-collection-shared/actionNames.ts";
import { DetailPanelContext } from "../detailPanel/DetailPanelContext.ts";
import { useGetProjects } from "../hooks/useGetProjects.ts";
import { useUserHasAction } from "../hooks/useUserHasAction.ts";
import { useTranslator } from "../i18n/translator";
import { CreateProjectDialog } from "./CreateProjectDialog.tsx";
import { InternalLink } from "./InternalLink.tsx";
import { UnavailableSidebarLink } from "./UnavailableSidebarLink.tsx";

export const SidebarComponent = () => {
  const translator = useTranslator();
  const userHasAction = useUserHasAction();
  const { openPanel, closePanel, attributes } = use(DetailPanelContext);
  const [isCreatingProject, setIsCreatingProject] = useState(false);

  const onCreateProject = () => {
    if (isCreatingProject) return closePanel();
    setIsCreatingProject(true);
    openPanel(<CreateProjectDialog onClose={closePanel} />, {
      onClose: () => setIsCreatingProject(false),
    });
  };

  const onProjectChange = attributes?.keepOpenOnProjectNavigation
    ? undefined
    : closePanel;

  const { isFetching, data: listOfProjects } = useGetProjects();
  return (
    <Box component="nav" sx={{ display: "contents" }}>
      <InternalLink
        title={translator("home")}
        pathname={"/"}
        icon={Cottage}
        onClick={closePanel}
      />
      <InternalLink
        title={translator("guide")}
        pathname={"/guide"}
        icon={HelpOutline}
        onClick={closePanel}
      />
      <InternalLink
        title={translator("mySignedCards")}
        pathname={"/my-signed-cards"}
        icon={Inventory2Icon}
        onClick={closePanel}
      />

      <UnavailableSidebarLink
        title={translator("myChristmasCardPortrait")}
        icon={Portrait}
        reason={translator("pageNotAvailable")}
        reasonId="christmasCardPortraitNotYetAvailable"
        tooltipIcon={ConstructionIcon}
        label={translator("comingSoon")}
      />

      <UnavailableSidebarLink
        title={translator("manualDispatchPageTitle")}
        icon={OutgoingMail}
        reason={translator("manualDispatchNotYetAvailable")}
        reasonId="manualDispatchNotYetAvailable"
        tooltipIcon={MailLockIcon}
        label={translator("comingSoon")}
      />

      {userHasAction(ActionNames.searchAllCards) && (
        <InternalLink
          title={translator("globalSearch")}
          pathname={"/search"}
          icon={Search}
          onClick={closePanel}
        />
      )}
      {userHasAction(ActionNames.viewCardErrors) && (
        <InternalLink
          title={translator("cardErrors")}
          pathname={"/errors"}
          icon={ReportProblemOutlined}
          onClick={closePanel}
        />
      )}
      <SidebarSectionTitle title={translator("projects")} />
      {userHasAction(ActionNames.createProject) && (
        <SidebarLink
          title={translator("createProject")}
          icon={Add}
          onClick={onCreateProject}
          selected={isCreatingProject}
        />
      )}
      <>
        {isFetching && (
          <Stack alignItems="center">
            <LoadingSpinner />
          </Stack>
        )}
        {listOfProjects?.map((item) => (
          <InternalLink
            key={item.id}
            title={item.displayName}
            pathname={`/projects/${item.id}`}
            icon={Checklist}
            onClick={onProjectChange}
          />
        ))}
      </>
    </Box>
  );
};
